import TermsContent from "../components/TermsContent/TermsContent";
import PublicLayout from "../components/Layout/PublicLayout";

const Terms = () => {
    return(
    <PublicLayout>
        <TermsContent />
    </PublicLayout>
)
}

export default Terms;

